import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AlertBox from "../../component/AlertBox";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import ButtonCompo from "../../component/ButtonCompo";
import PaginationBar from "../../component/PaginationBar";

function AllAttendance() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [leaveData, setLeaveData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [search, setSearch] = useState("");
  const [reload, setReload] = useState(false);

  // fetch leave applications
  async function getLeave() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/manager/get/all/attendance/${page}?search=${search}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setLeaveData(res.data?.data?.data);
      setTotalPage(res.data?.data?.totalPages);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Attendance data fetch failed");
    } finally {
      setLoading(false);
    }
  }

  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  useEffect(() => {
    getLeave();
  }, [reload, page]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            All Attendance
          </h1>
          <div className="w-full mt-5 flex justify-end items-end gap-5">
            <ButtonCompo
              variant={"outlined"}
              onClick={() => {
                setSearch("");
                setReload((prev) => !prev);
              }}
            >
              Reload
            </ButtonCompo>
            <section className="w-auto flex items-center gap-3">
              <TextField
                label="Search"
                size="small"
                onChange={(eve) => setSearch(eve.target.value)}
              />
              <ButtonCompo
                variant={"contained"}
                onClick={() => setReload((prev) => !prev)}
              >
                Search
              </ButtonCompo>
            </section>
          </div>
          <div className="mt-5 w-full">
            <Table>
              <TableHead>
                <TableRow className="bg-blue-500">
                  <TableCell className="!text-white !text-center">
                    Employee ID
                  </TableCell>
                  <TableCell className="!text-white !text-center">
                    Name
                  </TableCell>
                  <TableCell className="!text-white !text-center">
                    Role
                  </TableCell>
                  <TableCell className="!text-white !text-center">
                    Date
                  </TableCell>
                  <TableCell className="!text-white !text-center">
                    Day
                  </TableCell>
                  <TableCell className="!text-white !text-center">
                    Status
                  </TableCell>
                  <TableCell className="!text-white !text-center">
                    Login
                  </TableCell>
                  <TableCell className="!text-white !text-center">
                    Logout
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="border">
                {leaveData?.map((e, i) => (
                  <TableRow key={i}>
                    <TableCell className="!text-center">
                      <span className="text-[13px] px-3 py-1 bg-blue-200/40 border-blue-300 border text-blue-700 font-medium rounded-full">
                        {e?.user?.employeeId}
                      </span>
                    </TableCell>
                    <TableCell className="!text-center">
                      {e?.user?.fullName}
                    </TableCell>
                    <TableCell className="!text-center">
                      {e?.user?.role}
                    </TableCell>
                    <TableCell className="!text-center">{`${e?.dayOfMonth}-${
                      Number(e?.month) + 1
                    }-${e?.year}`}</TableCell>
                    <TableCell className="!text-center">
                      {days[Number(e?.dayOfWeek)]}
                    </TableCell>
                    <TableCell className="!text-center">{e?.status}</TableCell>
                    <TableCell className="!text-center">
                      {e?.actualLoginTimeStamp || "N/A"}
                    </TableCell>
                    <TableCell className="!text-center">
                      {e?.actualLogoutTimeStamp || "N/A"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <PaginationBar
              attendancePage={page}
              setAttendancePage={setPage}
              totalAttendancePage={totalPage}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default AllAttendance;
